import { Container, Typography } from "@mui/material";
import ScrollableFlexContainer from "@entrilia/shared/components/ScrollableFlexContainer";
import usePageTitle from "@entrilia/shared/hooks/usePageTitle";
import GeneralPageHeader from "../../../common/GeneralPageHeader";
import AppsDashboard from "./AppsDashboard";
import IntegrationsDashboard from "./IntegrationsDashboard";

const IntegrationsPage = () => {
  usePageTitle("Apps & Integrations");

  return (
    <>
      <GeneralPageHeader title="Apps & Integrations" />
      <ScrollableFlexContainer>
        <Container maxWidth={false} sx={{ py: 2.5, flex: 1 }}>
          <Typography variant="h6" sx={{ mb: 2 }}>
            Entrilia Environment
          </Typography>
          <AppsDashboard />
          <Typography variant="h6" sx={{ mt: 4, mb: 2 }}>
            Integrations
          </Typography>
          <IntegrationsDashboard />
        </Container>
      </ScrollableFlexContainer>
    </>
  );
};

export default IntegrationsPage;
